import { Component, inject } from '@angular/core';
import { MachinesSearchService, ToolingSearchService } from 'src/services';
import { StepBaseComponent } from '../../step-base.component';
import { GridV2Module } from '@schenck/rotec-components';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'machines-step',
  templateUrl: './machines-step.component.html',
  styleUrls: ['./machines-step.component.less'],
  imports: [GridV2Module, AsyncPipe, TranslatePipe],
})
export class MachinesStepComponent extends StepBaseComponent {
  constructor() {
    const machinesService = inject(MachinesSearchService);
    const toolingService = inject(ToolingSearchService);

    super(machinesService, toolingService);

    this.appliedSearchText = this.machinesService.state.fulltext;
  }
}
